import { Application } from "@hotwired/stimulus"
import DragController from "./drag_controller"

const application = Application.start()
application.register("drag", DragController)
